import {
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tooltip,
  useDisclosure,
  Tag,
  TagLabel,
  TagCloseButton,
  HStack,
  Grid,
  Spinner,
  Button,
} from '@chakra-ui/react';
import LicenseReviewTable from './components/LicenseReview';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Stores from './components/stores';
import { Link, useParams } from 'react-router-dom';
import { RouteParams } from '@/common/types';
import FFLSelectGlobalConfig from './components/FFLSelectGlobalConfig';
import ModalComponent from '@/common/Modal';
import CreateStore from './components/createStore';
import { CREATE_STORE_LABELS, ExportFFLLiveUserEnum, reviewChipValues } from '@/utils/constants';
import SOTTaxStampsTable from './components/SOTTaxStamps';
import Filters from './filters/Filters';
import LOAReviewTable from './components/LOAReview';
import { LicenseApprovalFilters } from './filters/LicenseApprovalFilters';
import { getFFLExportLiveUsersList, getIsExportFFLLiveUserClicked, getIsRefreshingLicenseApproval, getIsRefreshingLOAApproval, getIsRefreshingSOTApproval, getLicenseApprovalFilterModel, getLicenseApprovalSort, getLOAApprovalFilterModel, getLOAApprovalSort, getSOTApprovalFilterModel, getSOTApprovalSort, getStoresFilterModel } from './components/selector';
import { useDispatch, useSelector } from "react-redux";
import { callToGetExportFFLLiveUsers, defaultExportFFLLiveStoreusersModel, setGetFFLExportLiveStoreusers, setIsExportFFLLiveUserClicked, setIsRefreshingLicenseApproval, setIsRefreshingLOAApproval, setIsRefreshingSOTApproval, setLicenseApprovalFilterModel, setLicenseApprovalSort, setLOAApprovalFilterModel, setLOAApprovalSort, setSOTApprovalFilterModel, setSOTApprovalSort, setStoresFilterModel } from './ducks/slice';
import { LicenseApprovalFilterModel } from './types';
import Search from './filters/Search';
import { SOTApprovalFilters } from './filters/SOTApprovalFilters';
import { LOAApprovalFilters } from './filters/LOAApprovalFilters';
import {
  getIsCreateStoreLoading,
  getIsGlobalOperations,
} from '@/redux/app-selectors';
import { setDomainError, setEmailError, setStoreLicenseError } from '@/redux/app-slice';
import StoreFilter from './filters/storeFilter';
import SortByDropDown from './sort/sortComponent';
import s3Utils from '@/utils/s3Utils';
import { OutlineToasterNotification } from '@/toaster/successNotification';
import { Toastertype } from '@/dealerProfile/types';
import { ToastContainer } from 'react-toastify';
import { AgGridReact } from 'ag-grid-react';
import { LicenseReview, LOAReview, SOTTaxStamps } from '@/model/license-review.mjs';
import LicenseReviewDataSource from './ducks/licenseReviewDatasource';
import SOTTaxStampsDataSource from './ducks/SOTTaxStampsDatasource';
import LOATaxStampsDataSource from './ducks/LOATaxStampsDatasource';

const adminTabNames: RouteParams = {
  stores: '0',
  'license-approval': '1',
  'sot-tax-stamps': '2',
  'loa-approval': '3',
  'ffl-select': '4',
};
const globalOperationsTabNames: RouteParams = {
  'license-approval': '0',
  'sot-tax-stamps': '1',
  'loa-approval': '2',
};
function Review() {
  const dispatch = useDispatch();
  const isCreateStoreLoading = getIsCreateStoreLoading();
  const isGlobalOperations = getIsGlobalOperations();
  const [refetch, setRefetch] = useState<number>(0);
  /** Bumped when the header Refresh control is clicked so gallery view refetches (grid may be unmounted). */
  const [licenseToolbarRefreshNonce, setLicenseToolbarRefreshNonce] =
    useState(0);
  const [sotToolbarRefreshNonce, setSotToolbarRefreshNonce] = useState(0);
  const [loaToolbarRefreshNonce, setLoaToolbarRefreshNonce] = useState(0);
  const { tabName } = useParams<RouteParams>();
  const {
    isOpen: isCreteStoreOpen,
    onOpen: onCreteStoreOpen,
    onClose: onCreteStoreClose
  } = useDisclosure();
  const licenseApprovalFilterModel = getLicenseApprovalFilterModel();
  const sotApprovalFilterModel = getSOTApprovalFilterModel();
  const loaApprovalFilterModel = getLOAApprovalFilterModel();
  const adminStoreFilterModel = getStoresFilterModel();
  const licenseApprovalSort = getLicenseApprovalSort();
  const sotApprovalSort = getSOTApprovalSort();
  const loaApprovalSort = getLOAApprovalSort();
  const getExportFFLLiveUsers = getFFLExportLiveUsersList()
  const isExportFFLLiveUserClicked = getIsExportFFLLiveUserClicked()
  const isRefreshingLicenseApproval = getIsRefreshingLicenseApproval()
  const isRefreshingSOTApproval = getIsRefreshingSOTApproval()
  const isRefreshingLOAApproval = getIsRefreshingLOAApproval()
  const licenseApprovalGridRef = useRef<AgGridReact<LicenseReview>>(null);
  const sotApprovalGridRef = useRef<AgGridReact<SOTTaxStamps>>(null);
  const loaApprovalGridRef = useRef<AgGridReact<LOAReview>>(null);


  const approvalFilterKeys = {
    'license-approval': {
      approvalFilterModel: licenseApprovalFilterModel,
      setApprovalFilterModel: setLicenseApprovalFilterModel,
    },
    'sot-tax-stamps': {
      approvalFilterModel: sotApprovalFilterModel,
      setApprovalFilterModel: setSOTApprovalFilterModel,
    },
    'loa-approval': {
      approvalFilterModel: loaApprovalFilterModel,
      setApprovalFilterModel: setLOAApprovalFilterModel,
    },
    'stores': {
      approvalFilterModel: adminStoreFilterModel,
      setApprovalFilterModel: setStoresFilterModel,
    },
  }
  const onRemoveFilter = (value: string, key: string) => {
    const updatedFilterState = tabName && Object.entries((approvalFilterKeys as any)[tabName].approvalFilterModel)?.reduce((acc, [stateKey, item]: any) => {
      if (key === stateKey) {
        if (item?.values?.length && item.values.includes(value)) {
          item = {
            ...item,
            values: item?.values.filter((s: string) => s !== value)
          }
        } else if (item?.filter === value) {
          item = {
            ...item,
            filter: ''
          }
        } else if (`${item?.dateFrom} : ${item?.dateTo}` === value) {
          item = {
            ...item,
            dateFrom: '',
            dateTo: '',
          }
        }
      }
      return {
        ...acc,
        [stateKey]: item
      }
    }, {});
    dispatch((approvalFilterKeys as any)[tabName as string].setApprovalFilterModel(updatedFilterState as LicenseApprovalFilterModel));
  }

  const getChipValue = (item: any) => {
    if (item?.values && item?.values?.length) return item?.values;
    if (item?.filter) return [item.filter];
    if (item?.dateFrom && item?.dateTo) return [`${item?.dateFrom} : ${item?.dateTo}`];
    return [];
  }

  const isChipsDataExist = useMemo(() =>
    ((approvalFilterKeys as any)[tabName as string]?.approvalFilterModel) ? Object.values((approvalFilterKeys as any)[tabName as string]?.approvalFilterModel)?.some((item: any) => item?.values?.length || item?.filter?.length || item?.dateFrom?.length) : false
    , [licenseApprovalFilterModel, sotApprovalFilterModel, loaApprovalFilterModel, adminStoreFilterModel, tabName])

  useEffect(() => {
    setRefetch(Number(isGlobalOperations ? globalOperationsTabNames[tabName as string] : adminTabNames[tabName as string]));
  }, [isGlobalOperations, tabName]);

  const downloadCSV = async () => {
    const filePath = getExportFFLLiveUsers.filePath
    await s3Utils.getFile(filePath, "miscellaneous", { public: '' });
    OutlineToasterNotification(
      Toastertype.success,
      "CSV has been successfully downloaded.",
      () => { },
      ``,
      true
    );
  }

  useEffect(() => {
    const filePath = getExportFFLLiveUsers.filePath
    if (filePath) {
      downloadCSV()
      dispatch(setGetFFLExportLiveStoreusers(defaultExportFFLLiveStoreusersModel));
      dispatch(setIsExportFFLLiveUserClicked(false));
    }
  }, [getExportFFLLiveUsers.filePath]);

  const generateCSVForLiveUsers = () => {
    if (getExportFFLLiveUsers?.status == ExportFFLLiveUserEnum.pending) {
      dispatch(callToGetExportFFLLiveUsers());
    } else if (getExportFFLLiveUsers?.status == ExportFFLLiveUserEnum.completed) {
      dispatch(setIsExportFFLLiveUserClicked(false));
    }
  }

  useEffect(() => {
    if (isExportFFLLiveUserClicked)
      generateCSVForLiveUsers()

  }, [isExportFFLLiveUserClicked])

  const refreshLiceseApproval = () => {
    setLicenseToolbarRefreshNonce((n) => n + 1);
    const api = licenseApprovalGridRef.current?.api;
    if (!api) {
      dispatch(setIsRefreshingLicenseApproval(false));
      return;
    }
    dispatch(setIsRefreshingLicenseApproval(true));
    api.showLoadingOverlay();
    const childComponent = licenseApprovalGridRef.current?.props
      ?.gridOptions?.serverSideDatasource as LicenseReviewDataSource;
    if (childComponent) {
      childComponent.setRefreshCompleteCallback(() => {
        licenseApprovalGridRef.current?.api?.hideOverlay();
        dispatch(setIsRefreshingLicenseApproval(false));
      });
    }
    api.refreshServerSide();
  };

  const refreshSOTApproval = () => {
    setSotToolbarRefreshNonce((n) => n + 1);
    const api = sotApprovalGridRef.current?.api;
    if (!api) {
      dispatch(setIsRefreshingSOTApproval(false));
      return;
    }
    dispatch(setIsRefreshingSOTApproval(true));
    api.showLoadingOverlay();
    const childComponent = sotApprovalGridRef.current?.props
      ?.gridOptions?.serverSideDatasource as SOTTaxStampsDataSource;
    if (childComponent) {
      childComponent.setRefreshCompleteCallback(() => {
        sotApprovalGridRef.current?.api?.hideOverlay();
        dispatch(setIsRefreshingSOTApproval(false));
      });
    }
    api.refreshServerSide();
  };

  const refreshLOAApproval = () => {
    setLoaToolbarRefreshNonce((n) => n + 1);
    const api = loaApprovalGridRef.current?.api;
    if (!api) {
      dispatch(setIsRefreshingLOAApproval(false));
      return;
    }
    dispatch(setIsRefreshingLOAApproval(true));
    api.showLoadingOverlay();
    const childComponent = loaApprovalGridRef.current?.props
      ?.gridOptions?.serverSideDatasource as LOATaxStampsDataSource;
    if (childComponent) {
      childComponent.setRefreshCompleteCallback(() => {
        loaApprovalGridRef.current?.api?.hideOverlay();
        dispatch(setIsRefreshingLOAApproval(false));
      });
    }
    api.refreshServerSide();
  };

  return (
    <>
      <Tabs
        index={Number(isGlobalOperations ? globalOperationsTabNames[tabName as string] : adminTabNames[tabName as string])}
        position="relative"
        variant="unstyled"
        colorScheme="black"
        height={'100%'}
        onChange={(e: number) => {
          setRefetch(e);
        }}
      >
        <TabList>
          <Box className='tabs-box-container-wrapper'>
            {!isGlobalOperations && <Link to="/admin/stores">
              <Tab className="tabs-box">Stores</Tab>
            </Link>}
            <Link to="/admin/license-approval">
              <Tab className="tabs-box">License Approval</Tab>
            </Link>
            <Link to="/admin/sot-tax-stamps">
              <Tab className="tabs-box">SOT Approval</Tab>
            </Link>
            <Link to="/admin/loa-approval">
              <Tab className="tabs-box">LOA Approval</Tab>
            </Link>
            {!isGlobalOperations && <Link to="/admin/ffl-select">
              <Tab className="tabs-box">FFL Select</Tab>
            </Link>}
          </Box>
          <Box className='tabs-action-container'>
          {!isGlobalOperations && refetch === 0 && (
            <Box className='create-store-container'>
              <button
                className='refresh-btn-queue export-btn-custom'
                onClick={() => {
                  dispatch(setGetFFLExportLiveStoreusers(defaultExportFFLLiveStoreusersModel));
                  dispatch(setIsExportFFLLiveUserClicked(true));
                }}
                disabled={isExportFFLLiveUserClicked}
                style={{
                  marginRight: '20px',
                  cursor: isExportFFLLiveUserClicked ? 'not-allowed' : 'pointer',
                  opacity: isExportFFLLiveUserClicked ? 0.6 : 1
                }}>
                Download Store Users
                {isExportFFLLiveUserClicked && (
                  <Spinner
                    size="sm"
                    style={{
                      marginLeft: '8px'
                    }}
                  />
                )}
              </button>
              <Box sx={{ marginRight: '1rem' }}>
                <Filters title={"Filters"} customClass='store-filter' >
                  <StoreFilter />
                </Filters>
              </Box>
              <Tooltip
                hasArrow
                placement="top"
                label="Create New Store"
                color={'black'}
                bg={'white'}
              >
                <button
                  className="license_details__create-transer-btn"
                  onClick={onCreteStoreOpen}
                >
                  +
                </button>
              </Tooltip>
            </Box>
          )}
          {
            tabName === 'license-approval' && (
              <Box className='create-store-container'>
                <Tooltip
                  hasArrow
                  placement="top"
                  label="Refresh"
                  color={'black'}
                  bg={'white'}
                >
                  <Button
                    isLoading={isRefreshingLicenseApproval}
                    spinner={
                      <img
                        className="refresh-btn__spinner"
                        src="/images/ui/refresh.svg"
                      />
                    }
                    sx={{ marginRight: '1rem' }}
                    className="refresh-btn-queue"
                    onClick={refreshLiceseApproval}
                  >
                    <img src="/images/ui/refresh.svg" />
                  </Button>
                </Tooltip>
                <Filters
                  title={"Filters"}
                  customClass='license-approval-filter-wrapper'
                >
                  <LicenseApprovalFilters />
                </Filters>
                <Box sx={{ marginLeft: '1rem' }}>
                  <SortByDropDown isFiltersDisabled={false} sortValue={licenseApprovalSort} onSortOptionsChange={(val: string) => dispatch(setLicenseApprovalSort(val))} />
                </Box>
              </Box>
            )
          }
          {
            tabName === 'sot-tax-stamps' && (
              <Box className='create-store-container'>
                <Tooltip
                  hasArrow
                  placement="top"
                  label="Refresh"
                  color={'black'}
                  bg={'white'}
                >
                  <Button
                    isLoading={isRefreshingSOTApproval}
                    sx={{ marginRight: '1rem' }}
                    spinner={
                      <img
                        className="refresh-btn__spinner"
                        src="/images/ui/refresh.svg"
                      />
                    }
                    className="refresh-btn-queue"
                    onClick={refreshSOTApproval}
                  >
                    <img src="/images/ui/refresh.svg" />
                  </Button>
                </Tooltip>
                <Filters
                  title={"Filters"}
                  customClass='sot-approval-filter-wrapper'
                >
                  <SOTApprovalFilters />
                </Filters>
                <Box sx={{ marginLeft: '1rem' }}>
                  <SortByDropDown isFiltersDisabled={false} sortValue={sotApprovalSort} onSortOptionsChange={(val: string) => dispatch(setSOTApprovalSort(val))} />
                </Box>
              </Box>
            )
          }
          {
            tabName === 'loa-approval' && (
              <Box className='create-store-container'>
                <Tooltip
                  hasArrow
                  placement="top"
                  label="Refresh"
                  color={'black'}
                  bg={'white'}
                >
                  <Button
                    isLoading={isRefreshingLOAApproval}
                    sx={{ marginRight: '1rem' }}
                    spinner={
                      <img
                        className="refresh-btn__spinner"
                        src="/images/ui/refresh.svg"
                      />
                    }
                    className="refresh-btn-queue"
                    onClick={refreshLOAApproval}
                  >
                    <img src="/images/ui/refresh.svg" />
                  </Button>
                </Tooltip>
                <Filters
                  title={"Filters"}
                  customClass='loa-approval-filter-wrapper'
                >
                  <LOAApprovalFilters />
                </Filters>
                <Box sx={{ marginLeft: '1rem' }}>
                  <SortByDropDown isFiltersDisabled={false} sortValue={loaApprovalSort} onSortOptionsChange={(val: string) => dispatch(setLOAApprovalSort(val))} />
                </Box>
              </Box>
            )
          }
          </Box>
        </TabList>
        {tabName === 'license-approval' && <Search approvalType={"License Approval"} placeholder={'Search by License Number, Business Name, Transfer Id, Store Name, Order Id, License Path, Reviewed By, Uploaded By'} />}
        {tabName === 'sot-tax-stamps' && <Search approvalType={"SOT Approval"} placeholder={'Search by License Number, Business Name, Transfer Id, Store Name, Order Id, License Path, Reviewed By, Uploaded By'} />}
        {tabName === 'loa-approval' && <Search approvalType={"LOA Approval"} placeholder={'Search by License Number, Business Name, Transfer Id, Store Name, Order Id, License Path, Reviewed By, Uploaded By'} />}
        {tabName && ['license-approval', 'sot-tax-stamps', 'loa-approval', 'stores'].includes(tabName) && <Grid templateColumns='repeat(1, 1fr)'>
          {
            // Object.values((approvalFilterKeys as any)[refetch].approvalFilterModel)?.some((item: any) => item?.values?.length || item?.filter?.length || item?.dateFrom?.length) && (
            isChipsDataExist && (
              <Box sx={{ marginTop: '12px' }} display={'inline'}>
                <HStack flexWrap="wrap">
                  {Object.entries((approvalFilterKeys as any)[tabName as string].approvalFilterModel || {})?.map(([key, item]: any, index: number) => {
                    if (key === "searchText") return null;
                    const values = getChipValue(item)
                    return values?.length ? (
                      <>
                        {values.map((value: string, i: number) => <Tag
                          key={`ap-filter-${(Math.random() + "").split(".")[1]}`}
                          className="search-chip-tags"
                          size="lg"
                          backgroundColor={'#D7EBF9'}
                          borderRadius="full"
                          variant="solid"
                          height={'35px'}
                          color={'#436175'}
                        >
                          <TagLabel sx={{ textTransform: 'capitalize' }}>
                            {(reviewChipValues as any)[value] || value}
                          </TagLabel>
                          <TagCloseButton
                            padding={'0px'}
                            fontSize={'24px'}
                            color={'#436175'}
                            onClick={() => onRemoveFilter(value, key)}
                          />
                        </Tag>)}
                      </>
                    ) : null
                  })}
                </HStack>
              </Box>
            )
          }
        </Grid>}
        <hr style={{ margin: '15px 0 0px 0' }} />
        <TabPanels>
          {!isGlobalOperations && <TabPanel paddingBottom={0}>
            <Stores doRefresh={refetch} />
            <ModalComponent
              isOpen={isCreteStoreOpen}
              onClose={() => {
                dispatch(setEmailError(''))
                dispatch(setDomainError(''));
                dispatch(setStoreLicenseError(''))
                if (!isCreateStoreLoading)
                  onCreteStoreClose()
              }}
              footer={null}
              variant={2}
              title={CREATE_STORE_LABELS.ONBOARD_STORE_LABEL}
              maxWidth="800px"
              className='create-store-modal'
            >
              <CreateStore onCreateStoreClose={onCreteStoreClose} />
            </ModalComponent>
          </TabPanel>}
          <TabPanel paddingBottom={0}>
            <LicenseReviewTable
              gridRef={licenseApprovalGridRef}
              doRefresh={refetch}
              toolbarRefreshNonce={licenseToolbarRefreshNonce}
              tabName={tabName}
              className={(isChipsDataExist && tabName === 'license-approval') ? 'approval-grid-container-shrink' : 'approval-grid-container-grow'}
            />
          </TabPanel>
          <TabPanel paddingBottom={0}>
            <SOTTaxStampsTable
              gridRef={sotApprovalGridRef}
              doRefresh={refetch}
              toolbarRefreshNonce={sotToolbarRefreshNonce}
              tabName={tabName}
              className={(isChipsDataExist && tabName === 'sot-tax-stamps') ? 'approval-grid-container-shrink' : 'approval-grid-container-grow'}
            />
          </TabPanel>
          <TabPanel paddingBottom={0}>
            <LOAReviewTable
              gridRef={loaApprovalGridRef}
              doRefresh={refetch}
              toolbarRefreshNonce={loaToolbarRefreshNonce}
              tabName={tabName}
              className={(isChipsDataExist && tabName === 'loa-approval') ? 'approval-grid-container-shrink' : 'approval-grid-container-grow'}
            />
          </TabPanel>
          <TabPanel paddingBottom={0}>
            <FFLSelectGlobalConfig />
          </TabPanel>
        </TabPanels>
      </Tabs>
      <ToastContainer hideProgressBar />
    </>
  );
}

export default Review;
